import NotFound from "pages/NotFound/NotFound";
import React, { lazy, Suspense } from "react";
import { useRoutes } from "react-router-dom";
import App from "./App";

const Homepage = lazy(() => import("./pages/Homepage/Homepage"));
const PokemonProfile = lazy(
  () => import("./pages/PokemonProfile/PokemonProfile")
);

export default function Router() {
  let element = useRoutes([
    {
      path: "/",
      element: <App />,
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <Homepage />
            </Suspense>
          ),
        },
        {
          path: "/pokemon/:pokemonIdName",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <PokemonProfile />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "*",
      element: <NotFound mainError={true} />,
    },
  ]);

  return element;
}
